export default {
    zh: {
        addNew: '新增自评报告',
        title: '品评人员校准',
        supSelfEvaluation: '供应商自评',
        calibration: '校准',
        cqsEmail: '邮箱',
        sendEmail: '发送邮件',
        user: '人员（中文）',
        addUser: '添加人员',
        project: '项目',
        spScore: 'SP自评分数',
        cqsScore: 'CQS评分',
        singleScore: '单项成绩',
        calibtrateScore: '校准成绩',
        CQSEvaluation: 'CQS品评',
        calibrationAnalysis: '校准分析明细',
        userCalibrationInfo: '人员校准结果',
        emailReceivers: '收件人（供应商邮箱）',
        plantEmailReceivers: '收件人（工厂质量人员）',
        emailTitle: '主题',
        emailContent: '内容',
        singleBatchScore: '单样品校准成绩',
        avgScore: '平均分',
        passStatus: '是否合格',
        downloadCertificate: '下载证书',
        sendCertificates: '发送证书',
        certificateStatus: '证书状态',
        inactiveSelect: '请选择需要Inactive的单据!',
        inactiveReason: '请填写Inactive原因',
        sourceSerialNo: "原报告单据编号",
        pickUpSourceWarn: "修改原单据编号将重新加载打分，可能覆盖已填数据，确认选择吗？",
        downloadCertificateWarning: '证书还未生成,无法进行下载！',
        sendCertificateSuccess: '证书发送成功',
        pleaseSelectProduct: '请选择产品!',
        sureToSubmit:'提交后无法修改，确认提交吗？'
    },
    en: {
        addNew: 'New self-assessment report',
        title: 'Sensory Calibration',
        supSelfEvaluation: 'Supplier Self Evaluation',
        calibration: 'Calibration',
        cqsEmail: 'Email',
        sendEmail: 'Send Email',
        plantEmailReceivers: 'Plant Quality Users',
        user: 'User(Chinese)',
        addUser: 'Add User',
        project: 'Project',
        CQSEvaluation: 'CQS Evaluation',
        spScore: 'Supplier Score',
        cqsScore: 'CQS Score',
        singleScore: 'Single Score',
        calibtrateScore: 'Calibtrate Score',
        calibrationAnalysis: 'Calibration Analysis',
        userCalibrationInfo: 'User Calibration Info',
        emailReceivers: 'To（Supplier Email）',
        emailTitle: 'Title',
        emailContent: 'Content',
        singleBatchScore: 'Single Batch Score',
        avgScore: 'Avgscore',
        passStatus: 'Pass Status',
        downloadCertificate: 'Download Certificate',
        sendCertificates: 'Send Certificates',
        certificateStatus: 'Certificate status',
        inactiveSelect: 'Please select the document that needs inactive!',
        inactiveReason: 'Please enter the reason',
        sourceSerialNo: "Source Serial No.",
        pickUpSourceWarn: "Modifying the Source Serial No. will reload the score, may overwrite the filled data, confirm the choice?",
        downloadCertificateWarning: 'The certificate has not been generated and cannot be downloaded！',
        sendCertificateSuccess: 'Certificate sent successfully',
        pleaseSelectProduct: 'Please select product!',
        sureToSubmit:'Cannot modify after submit, confirm the submission?'
    }
}
